export const STANLEY_QUERY_LEARN_MORE_URL =
  'https://helpdesk.telmarhelixa.com/en/article/getting-started-with-stanley-audience-advisor';
